import { memo, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../../Modal';
import BrochureEmailForm from './BrochureEmailForm';
import Brochure from '../../../Brochure';
import { removeTripFromBrochure } from '../../../../store/slices/brochure';
import { SearchStatus } from '../../../../constants';
import withSpinner from '../../../../HOCs/withSpinner';

const BrochureEmailModal = ({ isModalOpen, handleCloseModal, id }) => {
  const dispatch = useDispatch();
  const { brochure } = useSelector((state) => state.brochure);
  const { sendBrochureRequestStatus, saveBrochureStatus } = brochure;
  const currentBrochure = useSelector((state) => state.brochure.brochures[brochure.id]);
  const { travelAgency } = useSelector((state) => state.user);
  const brochureSettings = (travelAgency && travelAgency.settings
    && travelAgency.settings.brochureSettings) || {};
  const doHideHeading = !!brochureSettings.doHideHeading;
  const displayLabel = brochureSettings.DisplayName || 'Brochure';
  useEffect(() => {
    if (currentBrochure && currentBrochure.trips
      && currentBrochure.trips.length === 0 && brochure.trips.length === 0) {
      dispatch(removeTripFromBrochure({ savedBrochureId: brochure.id }));
      handleCloseModal();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, currentBrochure]);

  const loadingText = useMemo(() => {
    if (saveBrochureStatus && id) return `Updating ${displayLabel}...`;
    if (saveBrochureStatus) return `Saving ${displayLabel}...`;
    return 'Preparing preview...';
  }, [saveBrochureStatus, displayLabel, id]);

  return (
    <Modal
      open={isModalOpen}
      onClose={handleCloseModal}
    >
      <div className="p-8">
        {doHideHeading ? <></>
          : (
            <div className="text-theme font-bold sm:text-sm xl:text-lg">
              Send via Email
            </div>
          )}
        <BrochureEmailForm id={id} />

        {withSpinner(() => (brochure?.id ? <Brochure id={brochure.id} /> : <></>),
          sendBrochureRequestStatus !== SearchStatus.DONE, loadingText)}
      </div>
    </Modal>
  );
};

BrochureEmailModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  id: PropTypes.string,
};

BrochureEmailModal.defaultProps = {
  id: undefined,
};
export default memo(BrochureEmailModal);
